import { render, staticRenderFns } from "./BsCheckbox.vue?vue&type=template&id=6e4c0028&"
import script from "./BsCheckbox.vue?vue&type=script&lang=js&"
export * from "./BsCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports